type Snapshot={version:number;updatedAt:string;collections:Record<string,any[]>};
let pending:Promise<Snapshot>|undefined;
let expires=0;
export function loadPublicContent():Promise<Snapshot> {
  if(Date.now()>=expires) {pending=undefined;expires=Date.now()+30000;}
  if (!pending) pending=(async()=> {
    for(const url of ['/api/public-content','/content-baseline.json']) {
      try {
        const res=await fetch(url,{signal:AbortSignal.timeout(6000)});
        if(!res.ok) continue;
        const data=await res.json();
        if(data.version===1 && data.collections) return data;
      } catch { /* The preserved static copy also works without the API. */ }
    }
    throw Error('Không tải được bản nội dung đã lưu. Vui lòng thử lại.');
  })().catch(error=>{pending=undefined;throw error;});
  return pending;
}
export async function publicCollection(name:string):Promise<any[]> {
  return (await loadPublicContent()).collections[name]||[];
}
